import trim from "lodash/trim";

import { teamRoles } from "../../constants/teamRoles";
import createDocumentData from "../../utils/createDocumentData";
import runTransaction from "../../utils/runTransaction";

import createDiscussionChannelData from "../discussion/createDiscussionChannelData";

import { Production } from "./types/Production";

export default async function createProduction(firebase, data, user) {
	const db = firebase.firestore();

	if (data.title) {
		data.title = trim(data.title);
	}

	const workRef = data.workId && db.collection("works").doc(data.workId);
	const producerRef = db.collection("organizations").doc(data.producerId);
	const publisherRef = db.collection("organizations").doc(data.publisherId);

	const channels = [
		{
			id: "team",
			name: "team",
			teamRoles: [
				teamRoles.EDITOR,
				teamRoles.PROOFER,
				teamRoles.MANAGER,
				teamRoles.RECORDER,
				teamRoles.SUBCONTRACTOR,
			],
		},
		{
			id: "publisher",
			name: "publisher",
			users: data.publisherManagers || [],
			teamRoles: [teamRoles.MANAGER, teamRoles.PUBLISHER_MANAGER],
		},
		{
			id: "admin",
			name: "admin",
			teamRoles: [teamRoles.MANAGER],
		},
	];

	return runTransaction(
		firebase,
		[workRef, producerRef, publisherRef],
		(transaction, [work, producer, publisher]) => {
			if (work) {
				data.work = work;
			}

			data.producer = producer.id;
			data.producerName = producer.name;

			data.publisher = publisher.id;
			data.publisherName = publisher.name;

			if (data.publisherManagers) {
				data.publisherManagerIds = data.publisherManagers.map(({ id }) => id);
			}

			const production = Production.parse(createDocumentData(firebase, "productions", data));

			transaction.set(production.ref, production);

			for (const { id, name, users, teamRoles } of channels) {
				const channel = createDiscussionChannelData(firebase, {
					id: `${production.id}-${id}`,
					name,
					users,
					producerId: producer.id,
					teamRoles,
					subject: {
						...production,
						name: production.title,
						language: production.language,
					},
					seenByUserIds: [user.id],
					createdBy: user,
				});

				transaction.set(channel.ref, channel);
			}

			return production;
		},
	);
}
